export default __webpack_public_path__ + "static/media/Keynote_Default_Icon.356bad10.svg";